import React from "react";
import TopBar from "../../../components/TopBar";
import Header from "../../../components/headerfooter/Header";
import Footer from "../../../components/headerfooter/Footer";
import CallToAction from "../../../components/home/CallToAction";
import Breadcrumb from "../../../components/Breadcrumb";
import MobileFooter from "../../../components/MobileFooter";
import CaptionsSubtitleComp from "../../../components/categoriesall/TextWriting/CaptionsSubtitleComp";

const CaptionsSubtitle = () => {
  return (
    <>
      <TopBar />
      <Header />
      <Breadcrumb
        title="Captions or Subtitle "
        breadcrumbs={[
          { label: 'Categories', link: '/ai-tool-categories' },
          { label: 'Captions or Subtitle' },
        ]
      }
        paragraph="There are 28 AIs for Captions or Subtitle"
      
      />
      <CaptionsSubtitleComp />
      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default CaptionsSubtitle;
